import React from 'react';
import PropTypes from 'prop-types';
import styles from './uploadInteraction.scss';
import a11yIIBScreenReaderService from '../../../../services/a11yIIBScreenReaderService';

class CancelButton extends React.Component {
    static propTypes = {
        cancelUpload: PropTypes.func.isRequired,
        services: PropTypes.object.isRequired,
    };

    render() {
        const { t } = this.props.services.translationService;
        const ariaLabelValue = a11yIIBScreenReaderService.getAriaLabelValue(
            undefined,
            t('interactions.upload.a11yBtnCancel'),
        );
        return (
            <button
                className={styles.cancelButton}
                onClick={this.props.cancelUpload}
                aria-label={ariaLabelValue}
            >
                <i className="fa fa-times" aria-hidden="true" />{t('interactions.upload.btnCancel')}
            </button>
        );
    }
}

export default CancelButton;
